export const HOME = '/'
export const BROWSE = '/browse'
export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin'
export const USER = '/user'
export const MOVIE = '/movie'
export const NARUTO = '/movies'
export const SHIPPUDEN = '/series'